import React from 'react';
import styled from 'styled-components';
import { useAppSelector } from '../../../../../redux/hooks';
import { builderSelectedOptionsSelector } from '../../../../../redux/selectors/builder';
import { assertCondition } from '../../../../../utils/types';
import {
  QueryType,
  SignificanceModeKey,
} from '../../../../../utils/apollo/graphqlSchema';
import SignificanceBreakdownCriteria from './SignificanceBreakdownCriteria';
import SignificanceSegmentCriteria from './SignificanceSegmentCriteria';
import SignificanceExperimentCriteria from './SignificanceExperimentCriteria';
import { UnreachableCaseError } from 'ts-essentials';
import { borderedContent } from '../../../../../styles/shareableStyles';

const Container = styled.div`
  padding: 12px 16px;
  ${borderedContent};
`;

// Component will render a different criteria components based on selected mode
const SignificanceCriteria = () => {
  const selectedOptions = useAppSelector(builderSelectedOptionsSelector);

  assertCondition(selectedOptions?.type === QueryType.Significance);

  const selectedMode = selectedOptions.mode;

  switch (selectedMode) {
    case SignificanceModeKey.Breakdown: {
      return (
        <Container>
          <SignificanceBreakdownCriteria />
        </Container>
      );
    }
    case SignificanceModeKey.Segment: {
      return (
        <Container>
          <SignificanceSegmentCriteria />
        </Container>
      );
    }
    case SignificanceModeKey.Experiment: {
      return (
        <Container>
          <SignificanceExperimentCriteria />
        </Container>
      );
    }
    default:
      throw new UnreachableCaseError(selectedMode);
  }
};

export default SignificanceCriteria;
